import React, { useState, useMemo, useEffect } from 'react';

function MediaPreview({ file, onClose, onSend }) {
    const [caption, setCaption] = useState('');
    const [loading, setLoading] = useState(false);

    // Hooks SIEMPRE antes de cualquier return condicional
    const fileUrl = useMemo(() => {
        if (!file) return null;
        return URL.createObjectURL(file);
    }, [file]);

    useEffect(() => {
        return () => {
            if (fileUrl) URL.revokeObjectURL(fileUrl);
        };
    }, [fileUrl]);

    if (!file) return null;

    const isImage = file.type.startsWith('image/');
    const isVideo = file.type.startsWith('video/');
    const fileSizeMB = (file.size / 1024 / 1024).toFixed(1);

    const handleSend = async () => {
        setLoading(true);
        await onSend(file, caption);
        setLoading(false);
    };

    return (
        <div className="fixed-backdrop" style={{
            backgroundColor: 'rgba(0,0,0,0.85)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2000
        }}>
            <div style={{
                backgroundColor: '#fff',
                borderRadius: '12px',
                maxWidth: '500px',
                width: '90%',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '0 4px 20px rgba(0,0,0,0.5)'
            }}>
                {/* Header */}
                <div style={{ padding: '12px 16px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ margin: 0, fontSize: '16px' }}>Enviar Archivo</h3>
                    <button onClick={onClose} style={{ border: 'none', background: 'none', fontSize: '20px', cursor: 'pointer' }}>✕</button>
                </div>

                {/* Preview Area */}
                <div style={{ padding: '20px', display: 'flex', justifyContent: 'center', backgroundColor: '#f0f2f5', minHeight: '200px', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                    {isImage ? (
                        <img src={fileUrl} alt="Preview" style={{ maxWidth: '100%', maxHeight: '400px', objectFit: 'contain', borderRadius: '8px' }} />
                    ) : isVideo ? (
                        <>
                            <video
                                src={fileUrl}
                                controls
                                style={{ maxWidth: '100%', maxHeight: '400px', borderRadius: '8px' }}
                                playsInline
                            />
                            {file.size > 15 * 1024 * 1024 && (
                                <div style={{
                                    backgroundColor: '#e8f5e9',
                                    border: '1px solid #4caf50',
                                    borderRadius: '8px',
                                    padding: '8px 12px',
                                    fontSize: '13px',
                                    color: '#2e7d32',
                                    width: '100%',
                                    boxSizing: 'border-box'
                                }}>
                                    ℹ️ Video de <strong>{fileSizeMB} MB</strong> — se comprimirá automáticamente antes de enviar.
                                </div>
                            )}
                        </>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                            <div style={{ fontSize: '48px' }}>📄</div>
                            <div style={{ fontWeight: 500 }}>{file.name}</div>
                            <div style={{ fontSize: '12px', color: '#666' }}>{fileSizeMB} MB</div>
                        </div>
                    )}
                </div>

                {/* Footer / Caption */}
                <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {(isImage || isVideo) && (
                        <input
                            type="text"
                            placeholder="Añadir comentario..."
                            value={caption}
                            onChange={(e) => setCaption(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '10px 12px',
                                borderRadius: '8px',
                                border: '1px solid #e4e6eb',
                                outline: 'none',
                                fontSize: '14px',
                                boxSizing: 'border-box'
                            }}
                        />
                    )}

                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '5px' }}>
                        <button
                            onClick={onClose}
                            disabled={loading}
                            style={{
                                padding: '8px 16px',
                                borderRadius: '20px',
                                border: '1px solid #ddd',
                                backgroundColor: '#fff',
                                cursor: 'pointer',
                                fontWeight: 500
                            }}
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={handleSend}
                            disabled={loading}
                            style={{
                                padding: '8px 24px',
                                borderRadius: '20px',
                                border: 'none',
                                backgroundColor: '#00a884',
                                color: 'white',
                                cursor: loading ? 'wait' : 'pointer',
                                fontWeight: 500,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                        >
                            {loading ? 'Enviando...' : (
                                <>
                                    <span>Enviar</span>
                                    <span style={{ fontSize: '12px' }}>➤</span>
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MediaPreview;
